
import { createRiskProfile } from "./riskProfileFactory";


export const dummyProfile = () => {
    return createRiskProfile({});
}